import { AccountStatus } from 'dashboard/models/account-status';
import { AccountType, AccountTypesFilterOption } from 'dashboard/models/account-type';
import { AccountTypesActions, AccountTypesActionType } from 'dashboard/redux/actions/account-types';

export interface AccountTypesState {
  accountTypes: AccountType[];
  accountStatuses: AccountStatus[];
  filterOptions: AccountTypesFilterOption[];
}

export const initialAccountTypesState: AccountTypesState = {
  accountTypes: [],
  accountStatuses: [],
  filterOptions: [],
};

export default (
  state: AccountTypesState = initialAccountTypesState,
  action: AccountTypesActions,
) => {
  switch (action.type) {
    case AccountTypesActionType.SetAccountTypes: {
      return {
        ...state,
        accountTypes: action.payload.accountTypes,
        accountStatuses: action.payload.accountStatuses,
      };
    }
    case AccountTypesActionType.SetFilterOptions: {
      return {
        ...state,
        filterOptions: action.payload.filterOptions,
      };
    }
    default:
      return state;
  }
};
